@if (storeService.getScreenType() === ScreenType.OPCJE_DORECZENIA) { @if
(stepNumber === 0) {
<div class="fdx-o-grid fdx-o-grid--max-width">
  <app-page-header [title]="'Dokąd mamy doręczyć Twoją przesyłkę?'">
    @if (isDeliveryCourier() && storeService.isDeliveryPickupPointPosible() ===
    false) { Twoja przesyłka nie spełnia warunków by doręczyć ją do Punktu
    Partnerskiego FedEx.<br /><br />
    Wybierając usługę Direct2Retail (doręczenie do punktu), możesz nadać
    przesyłkę jednoelementową o maksymalnej wadze 20kg i wymiarach 50/40/30cm
    (D/S/W). <br />
    Do Punktu Partnerskiego FedEx możesz nadać tylko paczkę. } @else { Wprowadź
    dane adresowe odbiorcy, uzupełniając pola obowiązkowe. }
  </app-page-header>

  <app-main-option-buttons-wrapper>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="deliveryPointButtonAction()"
      [label]="'Doręczenie do punktu'"
      [iconPathForActiveButton]="'assets/images/station_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/station_icon_grey.png'"
      [isActive]="isDeliveryPoint()"></app-main-option-button>
    <app-main-option-button
      class="fdx-o-grid__item--4 fdx-o-grid__item--3@medium"
      (click)="deliveryCourierButtonAction()"
      [label]="'Doręczenie przez kuriera'"
      [iconPathForActiveButton]="'assets/images/courier_icon_white.png'"
      [iconPathForInActiveButton]="'assets/images/courier_icon_grey.png'"
      [isActive]="isDeliveryCourier()"></app-main-option-button>
  </app-main-option-buttons-wrapper>

  @if (isDeliveryPoint()) {
  <app-delivery-point-form></app-delivery-point-form>
  } @if (isDeliveryCourier()) {
  <app-delivery-courier-form></app-delivery-courier-form>
  }
</div>
} }
